import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { MewsBiUserOnboardingStatusEnum, useRepositoryQuery } from '@mews-commander/data-access';
import { hasPlatformScopeWithAccessAllEnterprises } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { useCommanderSelector } from '@mews-commander/utils';
import { useNavigationSearchResult } from './useNavigationSearchResult';
import { AssistantNavigation } from './AssistantNavigation';

export const useBusinessIntelligenceNavigation = (): AssistantNavigation[] => {
    const dashboardsListResult = useNavigationSearchResult(
        RouteName.BusinessIntelligenceIndex,
        TextKey.MewsBusinessIntelligence,
        {}
    );

    const canViewSensitiveReports = useCommanderSelector(canCurrentProfileViewSensitiveReports);
    const insightsEnabled = useFeatureFlag(FeatureFlag.insightsEnabled);
    const canAccessAllEnterprises = useCommanderSelector(hasPlatformScopeWithAccessAllEnterprises);

    const { data } = useRepositoryQuery('goodData', 'getParameters', {});
    const BIEnabled =
        data?.biOnboardingStatus !== MewsBiUserOnboardingStatusEnum.NotFound ||
        insightsEnabled ||
        canAccessAllEnterprises;

    if (!canViewSensitiveReports || !BIEnabled || !data?.biWorkspaceId) return [];

    return [dashboardsListResult];
};
